export enum ViewabilityEventConditions {
  On50PercentVisible = 'on50PercentVisible',
  On100PercentVisible = 'on100PercentVisible',
  OnNotVisible = 'onNotVisible'
}
